import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import Switch from '@mui/material/Switch';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import { useTheme } from '@mui/material/styles';

function NRSwitch({
  className,
  formControlSxProps,
  labelSxProps,
  size = 'medium',
  value,
  onChange,
  color = 'secondary',
  label,
  labelPlacement = 'start',
  error,
  disabled,
  helperText,
  values,
  noWrapLabel = false,
  formGroupSxProps
}) {
  const theme = useTheme();

  return (
    <FormControl
      className={className}
      size={size}
      disabled={disabled}
      error={error}
      sx={{
        color: theme.palette.text.primary,
        ...formControlSxProps
      }}
    >
      <FormGroup aria-label={`switch-${label}`} sx={{ ...formGroupSxProps }} row>
        <FormControlLabel
          sx={{ ...(noWrapLabel ? { whiteSpace: 'nowrap' } : {}), ...labelSxProps }}
          control={
            !values ? (
              <Switch size={size} value={value} onChange={onChange} color={color} checked={value} />
            ) : (
              <Grid component="label" container alignItems="center" spacing={1} sx={{ marginLeft: theme.spacing(2) }}>
                <Grid item>
                  <Typography variant="body1">{values[0]}</Typography>
                </Grid>
                <Grid item>
                  <Switch
                    sx={{
                      '& .MuiSwitch-switchBase': {
                        color: color === 'primary' ? theme.palette.primary.main : color === 'secondary' ? theme.palette.secondary.main : undefined
                      },
                      '& .MuiSwitch-track': {
                        backgroundColor:
                          color === 'primary' ? theme.palette.primary.dark : color === 'secondary' ? theme.palette.secondary.dark : undefined,
                        opacity: 0.5
                      }
                    }}
                    size={size}
                    checked={value}
                    onChange={onChange}
                    value={value}
                    color={color}
                  />
                </Grid>
                <Grid item>
                  <Typography variant="body1">{values[1]}</Typography>
                </Grid>
              </Grid>
            )
          }
          label={label}
          labelPlacement={labelPlacement}
        />
      </FormGroup>
      {!!helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
}

export default NRSwitch;
